module.exports = __webpack_public_path__ + "arrow-step-forward.83341c8766567acb629d.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-step-forward.svg
// module id = ../../../../../src/img/icon/arrow-step-forward.svg
// module chunks = styles